/**
 * PoweredByDuoNep Component
 *
 * Small "Powered by DuoNep" signature mark for co-branded documents.
 * DuoNep is the permanent product brand; this signs documents that
 * carry the organization's primary co-brand.
 *
 * Usage:
 *   <PoweredByDuoNep />
 */

import { Box, Typography } from '@mui/material'

const PoweredByDuoNep = ({ sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        mt: 2,
        ...sx,
      }}
    >
      <img src="/images/duonep-logo.png" alt="DuoNep" style={{ height: '16px' }} />
      <Typography variant="caption" sx={{ fontSize: '10px', color: '#919EAB' }}>
        Powered by DuoNep
      </Typography>
    </Box>
  )
}

export default PoweredByDuoNep
